import { FunctionalComponent, h } from 'preact';
import type { EmptyStateSpec } from './mock/types';

/** 空态（T04/T05/T07/T08/T09/T12/T13）：标题+说明+动作按钮 */
export const EmptyState: FunctionalComponent<{ spec: EmptyStateSpec; onAction: (kind: string) => void; big?: boolean; emoji?: string }> = ({ spec, onAction, big, emoji }) => (
  <div class={`vp-empty${big ? ' big' : ''}`}>
    <span class={big ? 'big-emoji' : 'vp-empty-emoji'} aria-hidden="true">{emoji ?? (
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4m10-4v4M3 10h18m-13 5h8" />
      </svg>
    )}</span>
    <b class="vp-empty-title">{spec.title}</b>
    {spec.desc ? <p class="vp-empty-desc">{spec.desc}</p> : null}
    <div class="vp-empty-actions">
      {spec.actions.map((a, i) => (
        <button key={a.kind} class={`vp-card-btn${i > 0 ? '' : ' solid'}`} style={{ minWidth: '2.2rem' }} onClick={() => onAction(a.kind)}>
          {a.label}
        </button>
      ))}
    </div>
  </div>
);

/** 首屏骨架（T01：不弹 Toast，成功后替换） */
export const SkeletonList: FunctionalComponent<{ label?: string }> = ({ label = '正在加载商品预告…' }) => (
  <div class="vp-skel-list" role="status" aria-label={label}>
    <p class="vp-loading-label">{label}</p>
    {[1, 2, 3].map((i) => (
      <div key={i} class="vp-skel-card">
        <span class="vp-skeleton" style={{ width: '2.3rem', height: '2.3rem', borderRadius: '0.2rem' }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.16rem' }}>
          <span class="vp-skeleton" style={{ height: '0.32rem', width: '70%' }} />
          <span class="vp-skeleton" style={{ height: '0.8rem', width: '100%' }} />
          <span class="vp-skeleton" style={{ height: '0.36rem', width: '45%' }} />
        </div>
      </div>
    ))}
  </div>
);
